/**
 * Brand Story — dark section with copy, "Read our story" link, hero image,
 * and a floating live-rating badge.
 */
export default function HomeBrandStory({ brand, liveAgg }) {
    return (
        <section className="relative py-12 sm:py-16 px-6 sm:px-10 overflow-hidden bg-zen-elevated">
            <div className="zen-radial-olive absolute inset-0 pointer-events-none opacity-40" />
            <div className="relative max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-center">
                <div className="lg:col-span-5">
                    <p className="text-[11px] uppercase tracking-[0.35em] text-zen-olive-light mb-5">
                        Our Story
                    </p>
                    <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-zen-cream leading-[1.05] mb-8">
                        Cannabis, treated like the craft it is.
                    </h2>
                    <div className="space-y-5 text-zen-cream-muted leading-relaxed text-base">
                        <p>
                            ZenZest was founded by a family of New Yorkers who
                            believe cannabis deserves the same thoughtful
                            curation as fine wine, specialty coffee, or a
                            perfectly built bookshop.
                        </p>
                        <p>
                            Every brand on our shelves is personally vetted by
                            our team. Every budtender is trained to understand
                            the plant, not just sell it. And every visit is
                            meant to feel calm, welcoming, and quietly
                            elevated.
                        </p>
                    </div>
                    <a
                        href={brand?.store_url || "https://zenzest.com"}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-block mt-10 text-[12px] uppercase tracking-[0.3em] border-b border-zen-olive-light text-zen-cream pb-2 hover:border-zen-cream transition-colors"
                    >
                        Read our story
                    </a>
                </div>
                <div className="lg:col-span-7 relative">
                    <div className="aspect-[4/5] sm:aspect-[5/6] overflow-hidden">
                        <img
                            alt="ZenZest dispensary interior"
                            className="w-full h-full object-cover"
                            loading="lazy"
                            src="https://customer-assets.emergentagent.com/job_zenzest-near-me/artifacts/xkyk453i_ZenZest%20Pic.jpeg"
                        />
                    </div>
                    <div className="absolute -bottom-6 -left-6 sm:-bottom-10 sm:-left-10 hidden sm:block w-52 h-52 bg-zen-bg border border-zen-ink/10 p-7">
                        <div className="font-serif text-5xl text-zen-olive font-light leading-none">
                            {Number(liveAgg.rating || 4.9).toFixed(1)}
                        </div>
                        <div className="text-[10px] uppercase tracking-[0.25em] text-zen-ink-soft mt-3">
                            Average rating
                        </div>
                        <div className="text-xs text-zen-ink-soft mt-1">
                            from {Number(liveAgg.count || 4380).toLocaleString()}+ Google reviews
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
